import moment from 'moment';

export const dateHasPassed = date => {
  const today = moment();
  return date ? moment(date).isBefore(today) : false;
};

export const CLIENT_SIDE_DATE_FORMAT = 'MM/DD/YYYY';
export const SERVER_SIDE_DATE_FORMAT = 'YYYY-MM-DD';

export const dateToClientSideFormat = date => {
  if (!date) {
    return moment().format(CLIENT_SIDE_DATE_FORMAT);
  } else {
    const serverDate = moment(date).format(SERVER_SIDE_DATE_FORMAT);
    return moment(serverDate).format(CLIENT_SIDE_DATE_FORMAT);
  }
};
